module.exports = __webpack_public_path__ + "static/media/sflogo.bb87f319.jpg";